import { Segmented } from 'antd';

const DEFAULT_SECTIONS = [
    { key: 'basic', label: '基本信息' },
    { key: 'pro', label: '专业信息' },
    { key: 'payment', label: '收款信息' },
    { key: 'more', label: '更多信息' },
];

export default function ExpertSectionAnchor({ sections = DEFAULT_SECTIONS, activeSection, onSectionChange }) {
    const options = sections.map(section => ({
        label: section.label,
        value: section.key,
    }));

    return (
        <div className="expert-profile-anchor">
            <Segmented block className="expert-profile-anchor__segmented" options={options} value={activeSection} onChange={onSectionChange} />
        </div>
    );
}
